import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fe7adb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "offer-wrapper" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "offer-img",
      src: $props.item.ImageURL,
      alt: $props.item.Name
    }, null, 8, _hoisted_2),
    _createVNode(_component_router_link, {
      class: "shadow",
      to: {
      name: 'Details',
      params: {
        category: $props.link,
        id: $props.item.ExclusiveOfferId
      }
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "title",
          textContent: _toDisplayString($props.item.Name)
        }, null, 8, _hoisted_3),
        _createElementVNode("h5", {
          class: "description",
          textContent: _toDisplayString($props.item.Description)
        }, null, 8, _hoisted_4)
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}